export enum IPostStatus {
  DRAFT = 'DRAFT',
  PUBLIC = 'PUBLIC',
  ACTIVE = 'ACTIVE',
}

export interface IMediaItem {
  type: 'image' | 'file' | 'video' | 'audio';
  url?: string;
  fileCabinetId?: number;
  name: string;
  description?: string;
  id?: number;
  mimeType?: string;
  transcoded?: {
    thumbnail?: string;
    medium?: string;
    high?: string;
    original?: string;
  };
  options?: {
    soundLevel?: number[];
    duration?: string;
    previewUrl?: string;
  };
  timestamp?: string;
  location?: string;
  profile?: {
    id: string | number;
    firstName?: string;
    lastName?: string;
    avatar?: string;
  };
}

export interface IPostCreatedBy {
  userId: string;
  displayName: string;
  avatarUrl?: string;
  role?: string;
}

export interface IMention {
  offset: number;
  length: number;
  key: number;
  profileId: number;
  block: number;
}
